import { render, staticRenderFns } from "./thirdparty.vue?vue&type=template&id=6f490e12&lang=pug&"
import script from "./thirdparty.vue?vue&type=script&lang=js&"
export * from "./thirdparty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports